export default {
  data () {
    return {
      cambiadoAlert: false
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiadoAlert) {
      let respuesta = confirm(this.$t('alertBeforeExit'))
      if (respuesta) {
        if(this.$store.state.incidencias.sourceGetDocuments != null) {
          this.$store.state.incidencias.sourceGetDocuments.cancel("Request cancel by user")
        }
        if(this.$store.state.incidencias.sourceGetSmallPicturesFirma != null) {
          this.$store.state.incidencias.sourceGetSmallPicturesFirma.cancel("Request cancel by user")
        }
        if(this.$store.state.incidencias.sourceGetSmallPicturesApertura != null) {
          this.$store.state.incidencias.sourceGetSmallPicturesApertura.cancel("Request cancel by user")
        }
        if(this.$store.state.incidencias.sourceGetSmallPicturesCierre != null) {
          this.$store.state.incidencias.sourceGetSmallPicturesCierre.cancel("Request cancel by user")
        }
        if(this.$store.state.incidencias.sourceGetSmallPicturesCierreFirma != null) {
          this.$store.state.incidencias.sourceGetSmallPicturesCierreFirma.cancel("Request cancel by user")
        }
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  methods: {
    alertPreRefresh (e) {
      if (this.cambiadoAlert) {
        let message = this.$t('alertBeforeExit')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    }
  }
}
